/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S9_Li4_LabelInputs */

const tr_onbilgi_s9_li4_label = /** @type {(inputs: Onbilgi_S9_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS kayıt sorgulaması (sicil bilgisidir, şikayet veya dava kanalı değildir):`)
};

const en_onbilgi_s9_li4_label = /** @type {(inputs: Onbilgi_S9_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS registry lookup (registry information, not a complaint or litigation channel):`)
};

const de_onbilgi_s9_li4_label = /** @type {(inputs: Onbilgi_S9_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS-Registerabfrage (Registerangabe, kein Beschwerde- oder Klageweg):`)
};

const ru_onbilgi_s9_li4_label = /** @type {(inputs: Onbilgi_S9_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка регистрации в ETBİS (сведения реестра, не канал подачи жалоб или исков):`)
};

/**
* | output |
* | --- |
* | "ETBİS registry lookup (registry information, not a complaint or litigation channel):" |
*
* @param {Onbilgi_S9_Li4_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s9_li4_label = /** @type {((inputs?: Onbilgi_S9_Li4_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S9_Li4_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s9_li4_label(inputs)
	if (locale === "de") return de_onbilgi_s9_li4_label(inputs)
	if (locale === "ru") return ru_onbilgi_s9_li4_label(inputs)
	return tr_onbilgi_s9_li4_label(inputs)
});